import type { IPermission, IRole, IRoleBinding, IRoleBindingDto } from '@condo/domain';
import { openDownloadLink } from '../shared';
import { getClient } from './api-client';

export const fetchRoleBindingsForUser = async (userId: string): Promise<IRoleBinding[]> =>
    getClient('basecamp')
        .get(`/authz/users/${userId}/role-bindings`)
        .then(response => response.data);

export const fetchRoleBindings = async (): Promise<Record<string, IRoleBinding[]>> =>
    getClient('basecamp')
        .get('/authz/role-bindings')
        .then(response => response.data);

export const deleteRoleBindingFromUser = async (userId: string, roleBindingId: number): Promise<void> =>
    getClient('basecamp')
        .delete(`/authz/users/${userId}/role-bindings/${roleBindingId}`)
        .then(response => response.data);

export const bindRolesToUser = async (userId: string, roleBindings: IRoleBindingDto[]): Promise<IRoleBinding[]> =>
    getClient('basecamp')
        .post(`/authz/users/${userId}/role-bindings`, { roleBindings })
        .then(response => response.data);

export const getAllRoles = async (): Promise<IRole[]> =>
    getClient('basecamp')
        .get('/authz/roles')
        .then(response => response.data);

export const getAllPermissions = async (): Promise<IPermission[]> =>
    getClient('basecamp')
        .get('/authz/permissions')
        .then(response => response.data);

export const updateRole = async (roleId: number, role: Partial<IRole>): Promise<IRole> =>
    getClient('basecamp')
        .patch(`/authz/roles/${roleId}`, { role })
        .then(response => response.data);

export const bulkUpdateRoles = async (roles: Partial<IRole>[]): Promise<void> =>
    getClient('basecamp')
        .patch(`/authz/roles/bulk`, { roles })
        .then(response => response.data);

export const deleteRole = async (roleId: number): Promise<IRole> =>
    getClient('basecamp')
        .delete(`/authz/roles/${roleId}`)
        .then(response => response.data);

export const createRole = async (role: IRole): Promise<IRole> =>
    getClient('basecamp')
        .post('/authz/roles', { role })
        .then(response => response.data);

export const exportAuthzToCSV = async (): Promise<void> => {
    const {
        data: { csv },
    } = await getClient('basecampMaintenance').post('/maintenance/export-authz-to-csv');

    const url = window.URL.createObjectURL(new Blob([csv]));
    openDownloadLink(url, 'authz.csv');
};
